import type { RootState } from '/business/shared/state/store';
import { isEqual } from 'es-toolkit';
import { createSelectorCreator, lruMemoize } from 'reselect';

const createDeepEqualSelector = createSelectorCreator(lruMemoize, isEqual);

export default createDeepEqualSelector(
  (state: RootState) => state.auth?.user?.account ?? null,
  (user = null) => user,
);
